import { logout } from 'reduxpath/ducks/Auth'

import { destroyUser } from 'utils/Auth'

function onLogout(next, replace, store) {
  const isLoggedOut = () => {
    destroyUser(next, replace)
    return window.location.replace('/')
  }
  return store.dispatch(logout(isLoggedOut))
}

export default {
  activity: {
    onLogout,
  },
  components: {},
}
